import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

// Connects to data-controller="materials"
export default class extends Controller {
  static targets = ['partId']

  initialize() {
    this.updateRate = debounce(this.updateRate, 800).bind(this)
  }

  selectPart(_event) {
    if (this.partIdTarget.value) {
      this.element.requestSubmit()
    }
  }

  updateRate(_event) {
    if (this.partIdTarget.value) {
      this.element.requestSubmit()
    }
  }
}
